import service from './request'

/**
 * 获取字典类型列表
 */
export const getListDictType = data => {
    return service({
        showLoading: true,//调用预加载
        url: '/platform/dictType/getList',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 字典类型信息添加
 */
export const addInfoDictType = data => {
  return service({
      showLoading: false,//调用预加载
      url: '/platform/dictType/addInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 字典类型信息修改
 */
 export const updateInfoDictType = data => {
  return service({
      showLoading: false,//调用预加载
      url: '/platform/dictType/updateInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 字典类型信息删除
 */
 export const delInfoDictType = data => {
  return service({
      showLoading: false,//调用预加载
      url: '/platform/dictType/delInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 获取字典列表
 */
export const getListDict = data => {
    return service({
        showLoading: true,//调用预加载
        url: '/platform/dict/getList',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 字典信息添加
 */
 export const addInfoDict = data => {
    return service({
        showLoading: false,//调用预加载
        url: '/platform/dict/addInfo',
        method: 'post',
        type: 'body',
        data
    })
}


/**
 * 字典信息修改
 */
 export const updateInfoDict = data => {
    return service({
        showLoading: false,//调用预加载
        url: '/platform/dict/updateInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 字典信息删除
 */
 export const delInfoDict = data => {
    return service({
        showLoading: false,//调用预加载
        url: '/platform/dict/delInfo',
        method: 'post',
        type: 'body',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/DictManagement.js